"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useNetworkObserver_1 = require("./useNetworkObserver");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return useNetworkObserver_1.default; } });
//# sourceMappingURL=index.js.map